import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CreditCard, CheckCircle2, Clock, XCircle, ExternalLink } from "lucide-react";

const STATUS = {
  paid: { text: "Ödendi", cls: "bg-emerald-100 text-emerald-700", icon: CheckCircle2 },
  pending: { text: "Bekliyor", cls: "bg-amber-100 text-amber-700", icon: Clock },
  failed: { text: "Başarısız", cls: "bg-rose-100 text-rose-600", icon: XCircle },
};

export default function PaymentHistory() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/payments/history").then(({ data }) => setOrders(data)).catch(() => setOrders([]));
  }, []);

  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <div>
        <h1 className="font-display text-2xl font-bold text-slate-900 flex items-center gap-2">
          <CreditCard className="w-6 h-6 text-indigo-600" /> Ödeme Geçmişim
        </h1>
        <p className="text-slate-500 mt-1 text-sm">Shopier üzerinden yaptığın tüm abonelik ödemeleri.</p>
      </div>

      {orders === null && <p className="text-sm text-slate-400 text-center py-10">Yükleniyor...</p>}

      {orders && orders.length === 0 && (
        <div className="bg-white border border-slate-200 rounded-2xl p-10 text-center" data-testid="no-payments">
          <div className="text-5xl mb-3">🧾</div>
          <p className="text-slate-600 font-semibold">Henüz bir ödemen yok.</p>
          <Link to="/abonelik" className="inline-block mt-4 bg-indigo-600 hover:bg-indigo-700 text-white font-bold px-6 py-3 rounded-xl">Premium'a Geç</Link>
        </div>
      )}

      <div className="space-y-3" data-testid="payment-list">
        {orders?.map((o) => {
          const s = STATUS[o.status] || STATUS.pending;
          return (
            <div key={o.order_id} data-testid={`payment-${o.order_id}`} className="bg-white border border-slate-200 rounded-2xl p-4 flex items-center gap-4">
              <div className="bg-indigo-50 text-indigo-600 rounded-xl p-3"><CreditCard className="w-5 h-5" /></div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-800 text-sm">{o.product}</p>
                <p className="text-xs text-slate-400">{new Date(o.created_at).toLocaleString("tr-TR")} · #{o.order_id.slice(0, 8)}</p>
              </div>
              <div className="text-right">
                <p className="font-extrabold text-slate-900">{parseFloat(o.amount).toLocaleString("tr-TR")} ₺</p>
                <span className={`inline-flex items-center gap-1 text-xs font-bold px-2 py-0.5 rounded-full mt-1 ${s.cls}`}>
                  <s.icon className="w-3 h-3" /> {s.text}
                </span>
              </div>
            </div>
          );
        })}
      </div>

      <a href="https://www.shopier.com/noktaders/50725616" target="_blank" rel="noreferrer"
        className="flex items-center justify-center gap-1.5 text-sm text-indigo-500 hover:text-indigo-700 font-semibold">
        Shopier ürün sayfası <ExternalLink className="w-4 h-4" />
      </a>
    </div>
  );
}
